exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1DbxJHIXZurQGygZpzmwdq {\n    background-color: #008A72;\n    text-align: center;\n    color: white;\n    padding-top: 42px;\n    padding-bottom: 42px;\n    margin: 0;\n}", ""]);

// exports
exports.locals = {
	"root": "_1DbxJHIXZurQGygZpzmwdq"
};